export default __webpack_public_path__ + "static/media/skolabasari.1e4ee1ed.png";